import * as React from "react";
import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { WizardStep } from "../common/WizardStep";
import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";
import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";

declare const isDesktopBrowser: boolean;

interface IVehicleModelStepProps extends IStepProps {
    vehicleModels: string[];
}

export class VehicleModelStep extends React.Component<IVehicleModelStepProps, IStepState> {

    state: IStepState;

    constructor(props: IVehicleModelStepProps) {
        super(props);

        this.handleOnClickVehicleModel = this.handleOnClickVehicleModel.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }

    handleOnClickVehicleModel(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.primaryVehicle.model = value;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.ADD_SECOND_VEHICLE);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        let vehicleModelsTouchOptions: any[] = [];

        for (var i = 0; i < this.props.vehicleModels.length; i++) {
            let vehicleTouchOptionId = "vehicleModel_" + this.props.vehicleModels[i].replace(/ |\//g, "_");
            let touchOptionClasses = "touch-list-option";
            let linkOptionClasses = this.props.model.primaryVehicle.model &&
                this.props.model.primaryVehicle.model === this.props.vehicleModels[i]
                ? " selected"
                : "";

            vehicleModelsTouchOptions.push(<div key={vehicleTouchOptionId} className={touchOptionClasses}><a className={linkOptionClasses} data-value={this.props.vehicleModels[i]} id={vehicleTouchOptionId} onClick={this.handleOnClickVehicleModel}>{this.props.vehicleModels[i]}</a></div>);
        }

        const sectionStyle = {
            display: 'block'
        }

        const columnsClass = isDesktopBrowser ? "touch-list threeColumn" : "touch-list oneColumn";

        return <React.Fragment>
            <LogStep lastStep="VehicleMake" nextStep="AddVehicle" stepNumber={QuoteFormEventType.VehicleModelStep} sectionName="VehicleModel" wizardName="AutoWizard" logStep={true}/>
            <div id="VehicleModelStep" className={sectionClasses} style={sectionStyle}>
                   <h3>Select Your Vehicle Model:</h3>
                   <div id="VehicleModel">
                        <div className={columnsClass}>
                           {vehicleModelsTouchOptions}
                       </div>
                   </div>
            </div>
            </React.Fragment>;
    }
}